'use strict';

var lingojsCore = require('@bookingcom/lingojs-core');

/* This file is auto-generated and should not be edited (see `forms-generate` script in package.json) */
var fakeIndex = 'fakeIndex';
/**
 *
 * Locale | Example output
 * --- | ---
 * `en-gb` | Monday
 * `en-us` | Monday
 * `es` | lunes
 *
 * ---
 *
 * Full CDF list: https://office.booking.com/admintranslate/site/translate.html?lang=all&aid=1&tag=/weekday_formatted_date/1/name_to
 */
var form = 'name_to';
lingojsCore.registerDynamicTags(lingojsCore.t('weekday_formatted_date', fakeIndex, 'name_to'));

module.exports = form;
//# sourceMappingURL=index.js.map
